import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=234a473c&scoped=true&"
import script from "./planDetail.vue?vue&type=script&lang=js&"
export * from "./planDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a473c",
  null
  
)

export default component.exports